var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Trader Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-item-trader-mode", {
                        attrs: { model: _vm.model.mode },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "mode", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Active Orders:", "hide-details": "" },
                        model: {
                          value: _vm.model.activeOrders,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "activeOrders", _vm._n($$v))
                          },
                          expression: "model.activeOrders",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3", md: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Side Menu", "hide-details": "" },
                        model: {
                          value: _vm.model.sideMenu,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "sideMenu", $$v)
                          },
                          expression: "model.sideMenu",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-tutorial-dropdown", {
                        attrs: {
                          model: _vm.model.tutorialAllow,
                          clearable: true,
                          label: "Tutorial Allow",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "tutorialAllow", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-tutorial-dropdown", {
                        attrs: {
                          model: _vm.model.tutorialBlock,
                          clearable: true,
                          label: "Tutorial Block",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "tutorialBlock", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "12" } },
                    [
                      _c("r-item-order-kind", {
                        attrs: {
                          models: _vm.model.acceptOrders,
                          label: "Common Orders",
                          multiple: true,
                        },
                        on: {
                          "update:models": function ($event) {
                            return _vm.$set(_vm.model, "acceptOrders", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                { staticClass: "mt-4" },
                [
                  _c("r-item-order-panel", {
                    attrs: {
                      items: _vm.model.customOrders,
                      title: "Custom Orders",
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "customOrders", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }